import { effect, Injectable } from '@angular/core';
import { AnalyticsService } from 'ngx-shared-services';
import { BehaviorSubject } from 'rxjs';
import { GlobalNavService, User } from 'ngx-global-nav';

/**
 * A service to easily implement mixpanel tracking
 */
@Injectable()
export class MixPanelService {
  APPLICATION_NAME = 'User Admin';
  EVENTS = {
    LOGIN: 'Login',
    VIEW_USER_ADMIN: 'View User Admin',
    VIEW_USER: 'View User',
    PROFILE: 'Profile',
    EDIT_USER: 'Edit User',
    SAVE_EDIT_USER: 'Save Edit User',
    CREATE_USER: 'Create User',
    EXIT_CREATE_USER: 'Exit Create User',
    CREATE_USER_STEP_1: 'Create User Step 1',
    CREATE_USER_STEP_1_SUCCESS: 'Create User Step 1 Success',
    CREATE_USER_STEP_2: 'Create User Step 2',
    CREATE_USER_STEP_3: 'Create User Step 3',
    CREATE_USER_STEP_4: 'Create User Step 4',
  };
  isInit = false;
  userInformation$ = new BehaviorSubject<User>(null);

  constructor(private analyticsService: AnalyticsService, private globalNavService: GlobalNavService) {
    effect(() => {
      this.globalNavService.userData$.subscribe((user) => {
        if (user && !this.isInit) {
          this.userInformation$.next(user);
          this.analyticsService.init(user.user_id, this.APPLICATION_NAME);
          this.analyticsService.setPage(this.APPLICATION_NAME);
          this.isInit = true;
        }
      });
    });
  }

  userCreateButton(): void {
    this.userInformation$.subscribe((user) => {
      if (user) {
        this.analyticsService.pushEvent(this.EVENTS.CREATE_USER, {});
      }
    });
  }

  userCreateExitButton(): void {
    this.userInformation$.subscribe((user) => {
      if (user) {
        this.analyticsService.pushEvent(this.EVENTS.EXIT_CREATE_USER, {});
      }
    });
  }

  userCreateStep(stepNumber: number): void {
    this.userInformation$.subscribe((user) => {
      if (user) {
        const eventName = this.EVENTS[`CREATE_USER_STEP_${stepNumber}`];
        this.analyticsService.pushEvent(eventName, {});
      }
    });
  }

  userCreateStepSuccess(): void {
    this.userInformation$.subscribe((user) => {
      if (user) {
        this.analyticsService.pushEvent(this.EVENTS.CREATE_USER_STEP_1_SUCCESS, {});
      }
    });
  }

  viewPage() {
    this.userInformation$.subscribe((user) => {
      if (user) {
        this.analyticsService.pushEvent(this.EVENTS.VIEW_USER_ADMIN, {});
      }
    });
  }

  viewUser() {
    this.userInformation$.subscribe((user) => {
      if (user) {
        this.analyticsService.pushEvent(this.EVENTS.VIEW_USER, {});
      }
    });
  }

  editUser() {
    this.userInformation$.subscribe((user) => {
      if (user) {
        this.analyticsService.pushEvent(this.EVENTS.EDIT_USER, {});
      }
    });
  }

  saveEditUser() {
    this.userInformation$.subscribe((user) => {
      if (user) {
        this.analyticsService.pushEvent(this.EVENTS.SAVE_EDIT_USER, {});
      }
    });
  }

  login() {
    this.analyticsService.pushEvent(this.EVENTS.LOGIN, {});
  }
}
